import React from 'react';

import './CustomButton.scss';

const CustomButton = ({title}) => (
    
  <button type='button' className='button__custom'>{title}</button>
  
  );


export default CustomButton;